/**
 * Utility to sanitize text inputs like titles, names, and headers.
 * Removes HTML tags, standardizes whitespace, and trims.
 */
export function sanitizeTitle(input: string | null | undefined): string {
  if (!input) return "";
  
  return input
    // Remove HTML tags
    .replace(/<[^>]*>?/gm, '')
    // Replace newlines, tabs, and multiple spaces with a single space
    .replace(/[\r\n\t]+/gm, ' ')
    .replace(/\s{2,}/g, ' ')
    // Remove invisible control characters (zero-width spaces, etc.)
    .replace(/[\u200B-\u200D\uFEFF]/g, '')
    // Remove null bytes
    .replace(/\0/g, '')
    .trim();
}
